import { render, staticRenderFns } from "./DialogTableRow.vue?vue&type=template&id=d920e228&"
import script from "./DialogTableRow.vue?vue&type=script&lang=js&"
export * from "./DialogTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports